import { Award, Users, BadgeCheck, Target, Layers3, MapPin } from "lucide-react";
import { WHY_US } from "../../data/content";
import { Reveal, Overline } from "./Reveal";

const ICONS = { Award, Users, BadgeCheck, Target, Layers3, MapPin };

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="relative bg-white bg-grid-slate py-16 sm:py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="max-w-2xl mb-14">
          <Reveal><Overline>Miért válasszon minket?</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-gradient-brand text-balance">
              Szakértelem, amelyre hosszú távon is számíthat
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10">
          {WHY_US.map((w, i) => {
            const Icon = ICONS[w.icon];
            return (
              <Reveal key={w.title} delay={(i % 3) * 0.08}>
                <div data-testid={`why-us-${i}`} className="group">
                  <div className="flex items-center gap-4">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-[#38A8CE] to-[#AECE2F] text-white">
                      <Icon className="h-6 w-6" />
                    </span>
                    <div className="h-px flex-1 bg-slate-200 group-hover:bg-emerald-300 transition-colors" />
                  </div>
                  <h3 className="mt-5 text-xl font-bold text-[#0E5A75]">{w.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{w.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
